import * as VueRouter from 'vue-router'

import qs from 'qs'
import Search from '@/views/search/Index.vue'
import Products from '@/views/products/Index.vue'
import Product from '@/views/product/Show.vue'
import Cart from '@/views/cart/Index.vue'
import Checkout from '@/views/checkout/Index.vue'
import CheckoutSuccess from '@/views/checkout/Success.vue'
import CheckoutFailed from '@/views/checkout/Failed.vue'
import PaymentRequest from '@/views/payment/PaymentRequest.vue'
import EmptyCartPage from '@/views/Error.vue'
import { useCartStore } from '@/stores/cart'

const router = VueRouter.createRouter({
    history: VueRouter.createWebHistory(import.meta.env.VITE_APP_ROUTE_WEB_HISTORY ?? ''),

    routes: [
        { path: '/', name: 'search', component: Search },
        { path: '/ponudbe', name: 'products.index', component: Products },
        // Catalog SEO listing pages: nastanitve/{country}[/{island-or-area}[/{city}[/{camp}]]]
        { path: '/nastanitve/:regionGroup', name: 'catalog.region-group', component: Products },
        { path: '/nastanitve/:regionGroup/:region', name: 'catalog.region', component: Products },
        { path: '/nastanitve/:regionGroup/:region/:location', name: 'catalog.location', component: Products },
        { path: '/nastanitve/:regionGroup/:region/:location/:property', name: 'catalog.property', component: Products },
        { path: '/ponudba/:slug', name: 'product.show', component: Product },
        { path: '/empty-cart', name: 'empty-cart', component: EmptyCartPage },
        { path: '/cart', name: 'cart', component: Cart },
        { path: '/checkout', name: 'checkout', component: Checkout },
        { path: '/checkout/:order', name: 'checkout.order', component: Checkout },
        { path: '/checkout/:order/payment', name: 'checkout.payment', component: PaymentRequest },
        { path: '/checkout/:order/success', name: 'checkout.success', component: CheckoutSuccess },
        { path: '/checkout/:order/payment/success', name: 'checkout.payment-success', component: CheckoutSuccess },
        { path: '/checkout/:order/payment/response', name: 'checkout.payment-response', component: PaymentRequest }
    ],

    // Custom query parser/stringifier for nested and array query params
    parseQuery: (query) =>
        qs.parse(query, {
            ignoreQueryPrefix: true
        }),

    stringifyQuery: (query) => {
        return qs.stringify(query, {
            encodeValuesOnly: true,
            skipNulls: true,
            arrayFormat: 'brackets'
        })
    }
})

const guardedRouteNames = new Set(['cart', 'checkout', 'checkout.order'])

const hasProductInCartItems = (items) => {
    return items.some((item) => {
        const modelType = item?.attributes?.modelType ?? item?.attributes?.model_type ?? item?.modelType ?? item?.model_type
        return modelType === 'product'
    })
}

router.beforeEach(async (to) => {
    if (!guardedRouteNames.has(String(to.name))) {
        return true
    }

    const redirectToEmptyCart = () => {
        if (window.location.pathname !== '/empty-cart') {
            window.location.assign('/empty-cart')
        }
    }

    try {
        const cartStore = useCartStore()
        const response = await cartStore.loadCart()
        const items = Array.isArray(response?.items) ? response.items : []

        if (items.length > 0 && hasProductInCartItems(items)) {
            return true
        }
    } catch {
        redirectToEmptyCart()
        return false
    }

    redirectToEmptyCart()
    return false
})

export default router
